import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CaptureStates } from '@models/payments';
import { useToast } from '@hooks/useToast';
import { getApiErrorMessage } from '@utils/apiError';

import { capturePayment } from './api';

export function useCapturePaymentMutation() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: capturePayment,
    onSuccess: (result) => {
      // A capture the provider accepted but has not settled yet is a success, not a failure — the
      // captured timestamp arrives later with the settle webhook.
      if (result.captureState === CaptureStates.CAPTURED) {
        toast.success('Payment captured');
      } else {
        toast.success('Capture requested — waiting for the provider to settle it');
      }
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error) ?? 'Failed to capture payment');
    },
  });
}
